// Robust cross-browser download helper.
// iOS Safari (mobile) silently ignores the `download` attribute on blob URLs,
// so we detect iOS and open the blob in a new tab (user saves via the share sheet).
// On desktop/Android we use the classic anchor click.
export function downloadBlob(data, filename, mime = 'application/octet-stream') {
  try {
    const blob = data instanceof Blob ? data : new Blob([data], { type: mime });
    const url = URL.createObjectURL(blob);

    const ua = navigator.userAgent || '';
    const isIOS = (/iPad|iPhone|iPod/.test(ua) && !window.MSStream)
      || (ua.includes('Mac') && 'ontouchend' in document); // iPadOS 13+ reports as Mac

    if (isIOS) {
      // Open the blob in a new tab; mobile Safari users save via the share sheet.
      const win = window.open(url, '_blank');
      if (!win) window.location.href = url;
      setTimeout(() => { try { URL.revokeObjectURL(url); } catch {} }, 10000);
      return true;
    }

    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.rel = 'noopener';
    link.target = '_blank';
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    setTimeout(() => {
      try { link.remove(); } catch { /* ignore */ }
      try { URL.revokeObjectURL(url); } catch { /* ignore */ }
    }, 1000);
    return true;
  } catch (err) {
    console.error('downloadBlob failed:', err);
    return false;
  }
}

/**
 * Direct-URL download — best for authenticated same-origin endpoints.
 * Browser uses its native download machinery, cookies go along automatically,
 * and mobile Safari respects Content-Disposition: attachment headers properly.
 */
export function downloadFromUrl(url, filename) {
  try {
    const link = document.createElement('a');
    link.href = url;
    if (filename) link.download = filename;
    link.rel = 'noopener';
    link.target = '_blank';
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    setTimeout(() => { try { link.remove(); } catch { /* ignore */ } }, 300);
    return true;
  } catch (err) {
    console.error('downloadFromUrl failed:', err);
    return false;
  }
}

